import { LocalStorageRegistry } from '@/constants/localStorageRegistry'
import { RADIUS_SLIDER_HALF_POINT_KMS } from '@/constants/location'

/**
 * Sets the local storage to define what was the user last set radius value
 * This will help return to this value whenever we automatically update the radius base on the browsed category
 */
export const setLastRadiusLocalStorage = (value?: number) => {
  const updatedValue = value || RADIUS_SLIDER_HALF_POINT_KMS

  window.localStorage.setItem(LocalStorageRegistry.USER_LAST_RADIUS_VALUE, updatedValue.toString())
}
